// extracted by mini-css-extract-plugin
module.exports = {"brandTeal":"#00b4a3","brandGold":"#d7be69","smokeGray":"#3b3b38","naturalWhite":"#f8f7ed","lightSand":"#e5e5e5"};